import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { RecordColumn } from "@/components/common/record"
import { StandingBadge } from "@/components/common/standing-badge"
import { DeclarationIssues } from "@/features/individuals/components/declaration-issues"
import { DeclarationSummary } from "@/features/individuals/components/declaration-summary"
import { DeclarationActions } from "@/features/individuals/components/individual-fitness-actions"
import { formatDate } from "@/lib/format"
import { fitnessQueries } from "@/queries/fitness"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/fitness/$assessmentId/"
)({
  staticData: { attention: "individual.fit_and_proper" },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      fitnessQueries.detail(params.individualId, params.assessmentId)
    ),
  component: DeclarationPage,
})

/** One fit and proper: what it came to, then what was asked and said. */
function DeclarationPage() {
  const { individualId, assessmentId } = Route.useParams()
  const { data: assessment } = useSuspenseQuery(
    fitnessQueries.detail(individualId, assessmentId)
  )

  return (
    <>
      <PageHeader
        title={`Fit and proper · ${formatDate(assessment.periodStart)}`}
        actions={
          <>
            <StandingBadge standing={assessment.standing} />
            <DeclarationActions
              individualId={individualId}
              assessment={assessment}
            />
          </>
        }
      />

      <RecordColumn>
        <DeclarationSummary assessment={assessment} />

        <DeclarationIssues
          individualId={individualId}
          issues={assessment.issues ?? []}
        />
      </RecordColumn>
    </>
  )
}
